import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabItemComponent } from './components/tab-component/tab-item/tab-item.component';
import { TabsComponent } from './components/tab-component/tabs/tabs.component';
import { HorizontalTimelineComponent } from './components/horizontal-timeline/horizontal-timeline.component';
import { AccordionComponent } from './components/accordion/accordion.component';



@NgModule({
  declarations: [ TabsComponent, TabItemComponent, HorizontalTimelineComponent, AccordionComponent],
  imports: [CommonModule],
  exports: [
    TabsComponent, TabItemComponent, HorizontalTimelineComponent, AccordionComponent
  ]
})
export class SuperAggregatorSharedModule { }
